// Shared navbar link styling, applied to plain next/link <Link> elements.

// Top-level navbar links, matching the dropdown-trigger buttons: Inconsolata,
// uppercase.
export const navbarLinkClass =
  'rounded-md text-sm whitespace-nowrap font-semibold uppercase font-mono tracking-[0.03em] text-white px-3 py-2'

// Dropdown menu items that are links (Menu.Item component={Link}). The
// Menu.Item itself must be the link so the entire row (including padding)
// navigates — a nested link inside the item leaves dead click zones.
export const dropdownItemClass =
  'rounded-md text-sm whitespace-nowrap font-medium text-[var(--mantine-color-celerityBrand-9)] hover:text-[var(--mantine-color-celerityBrand-5)]'
